import React, { Component } from "react";
import { Col, Container, Modal, ModalBody, Row } from "reactstrap";
import NavTab from "../../../components/common/global_layout/navTab2";
import Rating from "../../../components/common/rating";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import httpClient from "../../../httpClient";
import { Button, Comment, Form, Header } from "semantic-ui-react";
import "semantic-ui-css/semantic.min.css";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import FromToDate from "../../../components/common/Cars/fromToDate";
import PagePath from "../../../components/common/pagePath";
import Gallery from "../../../components/common/gellery";
import shared from "../../../shared";
import { announceId, authorId, textComment } from "../../../slices/commentSlice";
import { newMessage, reserve } from "../../../slices/modalSlice";
import moment from "moment";
import { addDataAnnounce, changeNbrPersonHb } from "../../../slices/reservationHebergSlice";

class DetailsGhurfaty extends Component {
  constructor(props) {
    super(props);
    const AnnounceId = this.props.match.params.id_hebergement;
    this.state = {
      AnnounceId: AnnounceId,
      detailHebergement: [],
      initialComments: [],
      equipement: [],
      commentAthors :[],
      comment: {
        text: "",
        rating: this.props.rating || 4,
        announce: AnnounceId,
        author: this.props.currentUser._id,
      },
      ratingModal: false,
      images: [],
      galleryId: "",
      nbrImages:0,
      nbrAdulte: 1,
      nbrRoom :1 ,
      nbrChildren :0,
      hostName:process.env.REACT_APP_SERVER_URL
    };
  }

  async componentDidMount() {
    await this.getAnnounceDetail();
    //incerement Vue numbe
    if (this.props.currentUser._id !== this.state.creator) {
      httpClient.incrVues(this.state.AnnounceId);
    }
  }

  getAnnounceDetail() {
    return httpClient
      .getAnnounceDetailRqst(this.state.AnnounceId)
      .then((res) => {
        this.setState({
          detailHebergement: res.annHeberg,
          creator : res.annHeberg.creator[0],
          galleryId: res.annHeberg.photos[0],
          initialComments: res.annHeberg.reviews,
          nbrImages: res.nbrImages,
          equipement: res.annHeberg.equipement,
          commentAthors : res.users,
          readMore : true,
          moreEquip : true
        });
        this.props.dispatch(addDataAnnounce(res.annHeberg))
      });
  }
   toggleReadMore (){
     this.setState({readMore : !this.state.readMore})
   }
   toggleMoreEquip (){
    this.setState({moreEquip : !this.state.moreEquip})
  }
   submitComment(e) {
    e.preventDefault();
   this.setState({
      ratingModal: true,
    });
    this.props.dispatch(textComment(this.state.comment.text))
    this.props.dispatch(announceId(this.state.comment.announce))
    this.props.dispatch(authorId(this.props.currentUser._id))
    const cmnt = this.state.comment;
    this.setState({
      comment: {
        ...this.state.comment,
        text: "",
      },
    });
    
  }

  async dataChange(evt) {
      await this.setState({
          [evt.target.name]: parseInt(evt.target.value)
      })
      const {nbrRoom,nbrAdulte,nbrChildren} = this.state ;
      this.props.dispatch(changeNbrPersonHb({nbrRoom,nbrAdulte,nbrChildren}))
  }
  
  onInputChange(evt) {
    this.setState({
      comment: {
        ...this.state.comment,
        text: evt.target.value,
      },
    });
  }

  toogleRatingClose() {
    this.setState({
      ratingModal: false, 
    });
    httpClient.postCommentAccommodation(this.props.comment).then((res) => {
      if (res.success === false) {
        this.props.dispatch({ type: "LOGIN_FORM" });
      } else {
        this.getAnnounceDetail();
      }
    });
  }
  contactAnnouncer = ()=>{
    this.props.dispatch(newMessage(this.state.creator))
  }
  reserveForm = () => {
    this.props.dispatch(reserve());
  };

  getOptions(opt) {
    return shared.getOptions(opt);
  }

  render() {
    const reviews = this.state.initialComments;
    var opt = this.getOptions(this.state.equipement);
    let users = this.state.commentAthors
    const option1 = opt.firstDivOptions.map(function (option, i) {
      return (
        <Col sm="6" id="equipement" className="icon-item">
          <Row>
            <Col>
              <img className="equipement-icon" src={`/imgs/equipements/${(option.charAt(0).toUpperCase() + option.slice(1)+ '.svg').replaceAll(" ","-").replaceAll('é','e').replaceAll('è','e') }`} alt={option} />
              <span className="eqm-name">{option.replaceAll("+"," ")}</span>
            </Col>
          </Row>
        </Col>
      );
    });
    const option2 = opt.secondDivOptions.map(function (option, i) {
      return (
        <Col sm="6" id="equipement" className="icon-item">
        <Row>
          <Col>
          <img className="equipement-icon" src={`/imgs/equipements/${(option.charAt(0).toUpperCase() + option.slice(1)+ '.svg').replaceAll(" ","-").replaceAll('é','e').replaceAll('è','e') }`} alt={option} />
            <span className="eqm-name">{option.replaceAll("+"," ")}</span>
          </Col>
        </Row>
      </Col>
      );
    });

    const reviewsBloc = reviews.map(function (itemRv, i) {
      var author = users.find(e => e._id === itemRv.author[0]);
      if (typeof author  === "undefined") {
        author = {name : "Unkown"}
      }
      return (
        <Comment className="commnets-block" key={i}>
          <Comment.Avatar
            src="https://react.semantic-ui.com/images/avatar/small/matt.jpg"
            style={{ width: "65px", height: "67px" }}
          />
          <Comment.Content>
            <Comment.Author as="a"><a href={`/agent/profile/${author._id}`}>{author.name}</a></Comment.Author>
            <Comment.Metadata>
              <div>{moment(itemRv.createdAt).format("DD/MM/YYYY")}</div>
              <div>
                <Rating
                  starts={itemRv.rating}
                  color={"gold"}
                  change={false}
                  size={"1.5rem"}
                  top={"6px"}
                />
              </div>
            </Comment.Metadata>
            <Comment.Text>{itemRv.text}</Comment.Text>
          </Comment.Content>
        </Comment>
      );
    });

    const {
      title,
      pays,
      region,
      commune,
      description,
      rating
    } = this.state.detailHebergement;
    const  {nbrRoom,nbrAdulte,nbrChildren} = this.state
    return (
      <>
        <NavTab  display="none" />
        <PagePath  pages={["Ghurfaty", "Hotels", title]} links={["/home","/hebergment","/hebergment"]} />
        <Container className="mt-5">
          <button className="type-heberg">
            <img
              src="/imgs/navebar/browsingIcons/hotelsWhite.svg"
              className="type-heberg-icon"
              alt=""
            />
            {this.state.detailHebergement.type}
          </button>
          <Row>
            <Col md="7">
              <div className="test">
                <Row className="d-flex justify-content-between align-items-center pl-3 mb-3">
                  <div className="d-flex flex-column">
                    <h2 id="Detail-title">{title}</h2>
                    <span id="detail-position">
                      <img
                        src="/imgs/announces/pinColor.svg"
                        alt=""
                        id="pin-position-detail"
                      />
                      {region} {commune}, {pays}
                    </span>
                  </div>
                  <div className="d-flex flex-column">
                    {rating &&<Rating size={"2.2rem"}   starts={rating} class="rating-detail" />}
                    <center>{reviews.length} Commentaire</center>
                  </div>
                </Row>
                <hr />
                <h4 id="Detail-title">Description</h4>
                <Col sm="10">
                { description && description.length > 130 &&
                <p className="desc-paragraph">
                   {this.state.readMore ? description.slice(0, 130)+" ..." : description}
                  
                   <span onClick={() => this.toggleReadMore()} className="read-or-hide">
                     {this.state.readMore ? <span style={{cursor : "pointer", textDecoration: "underline",color : "#37296a",fontWeight : 500, marginLeft : "8px"}}  className="text-nowrap">voir plus</span> : <span style={{cursor : "pointer", textDecoration: "underline",color : "#37296a",fontWeight : 500, marginLeft : "8px"}}>voir moins</span>}
                   </span>
                      
                </p>
                  }
                  {description && description.length <= 130 &&
                  <p className="desc-paragraph">
                     {description}
                  </p>
                   }
                  
                </Col>

                <hr />

                <h4 id="Detail-title">Equipement</h4>
                <Row className="icons-details">

                {option1.length === 0 && 
                  <Col sm="6" id="equipement" className="icon-item">
                  <Row>
                    <Col>
                      <span className="eqm-name">Equipement No mentioned</span>
                    </Col>
                  </Row>
                </Col>
                 }

                 {this.state.moreEquip ? option1.slice(0,3) : option1}

                 {this.state.moreEquip ? option2.slice(0,3) : option2}
          
                  

                </Row>
                <div className="d-flex container">
                    <span onClick={() => this.toggleMoreEquip()} className="read-or-hide">
                      {this.state.moreEquip ? <span style={{cursor : "pointer", textDecoration: "underline",color : "#37296a",fontWeight : 500}} className="text-nowrap">voir plus</span> : <span style={{cursor : "pointer", textDecoration: "underline",color : "#37296a",fontWeight : 500, marginLeft : "8px"}}>voir moins</span>}
                   </span>
                </div>
                
                <hr />
                
                

                {/* Calendar depart arrivé mobile */}
                <div className="date-mobile-view">
                  <h4 id="Detail-title-cmnts">Date Départ Arrivé</h4>
                  <div className="depart-arrive-block-mobile">
                    <div className="depart-date-mobile">
                      <span className="date-title-mobile">Départ</span>
                      <div>
                        <span className="date-numbr-mobile">18</span>
                      </div>
                      <span className="month-mobile">aout</span>
                    </div>

                    <div className="arrow-date-mobile">
                      <FontAwesomeIcon id="arrow_date" icon={faArrowRight} />
                    </div>

                    <div className="arrive-date-mobile">
                      <span className="date-title-mobile">Arrivé</span>
                      <div>
                        <span className="date-numbr-mobile">25</span>
                      </div>
                      <span className="month-mobile">septembre</span>
                    </div>
                  </div>
                </div>
                <br />
                <div className="persons-mobile-view">
                  <h4 id="Detail-title-cmnts">Capacité d'hebergement</h4>
                  <div className="depart-arrive-block-mobile">
                    <div className="depart-date-mobile">
                      <div className="name-persnmsmall">
                        Adultes{" "}
                        <span className="number-persnmsmall">{nbrAdulte}</span>
                      </div>
                      <div className="name-persnmsmall">
                        Enfants{" "}
                        <span className="number-persnmsmall">
                          {nbrChildren}
                        </span>
                      </div>
                    </div>
                    <div className="arrive-date-mobile">
                      <div className="name-persnmsmall">
                        Chambres
                        <span className="number-persnmsmall">{nbrRoom}</span>
                      </div>
                      <div className="name-persnmsmall">Vue sur mer</div>
                    </div>
                  </div>
                </div>

                <div className="persons-mobile-view">
                  <div className="button-contact-mobile">
                    <div className="padding0">
                      <a href="/messagerie">
                      <div className="contact-mobile">
                        Contacter l'annonceur
                        <img
                          src="/imgs/resrervationIcons/annoncer-contacts.svg"
                          alt=""
                          className="notifHear-iconOr icon-cnt-fr"
                        />
                      </div>
                      </a>
                      <div className="reserver-mobile">
                        <div onClick={this.reserveForm}>
                          Réserver maintenant
                          <img
                            src="/imgs/resrervationIcons/reserverMaintenant.svg"
                            alt=""
                            className="notifHear-iconOr icon-cnt-fr"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="comments-block">
                  <Comment.Group>
                    <Header dividing>
                      <h4 id="Detail-title-cmnts">Commentaires</h4>
                    </Header>

                    {reviewsBloc}

                    <Form reply onChange={this.onInputChange.bind(this)}>
                      <Form.TextArea
                        name="txt-cmnt"
                        value={this.state.comment.text}
                      />
                      <Button
                        content="Commenter"
                        onClick={this.submitComment.bind(this)}
                        labelPosition="left"
                        icon="edit"
                        primary
                      />
                    </Form>
                    <br />
                  </Comment.Group>
                </div>
              </div>
            </Col>

            <Col md="4" style={{ left: "60px", top: "-50px" }}>
              <div className="carPhotos respo-block">
                <Gallery
                  nbrImages ={this.state.nbrImages}
                  img={`${this.state.hostName}/api/announces/${this.state.galleryId}/avatar/0`}
                  galleryId={this.state.galleryId}
                />
                <FromToDate />
                <Row>
                  <form onChange={this.dataChange.bind(this)}>
                  <Col sm="12" className="prsn-number">
                    <div className="mt-2">
                      <Row>
                        <Col sm="6">
                          <Row>
                            <Col sm="6" className="name-persnmsmall">
                              Adultes
                            </Col>
                            <Col sm="5" className="number-persnmsmall">
                              {/* {nbrAdulte} */}
                              <input type="number"  min={1} className="number-input-announce" name="nbrAdulte" id="" value={nbrAdulte} />

                            </Col>
                          </Row>
                        </Col>
                        <Col sm="6">
                          <Row>
                            <Col sm="5" className="name-persnmsmall">
                              Enfants
                            </Col>
                            <Col sm="6" className="number-persnmsmall">
                              {/* {nbrChildren} */}
                              <input type="number"  min={0} className="number-input-announce" name="nbrChildren" id="" value={nbrChildren} />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm="6">
                          <Row>
                            <Col sm="6" className="name-persnmsmall">
                              Chambres
                            </Col>
                            <Col sm="5" className="number-persnmsmall">
                              {/* {nbrRoom} */}
                              <input type="number"  min={1} className="number-input-announce" name="nbrRoom" id="" value={nbrRoom} />
                            </Col>
                          </Row>
                        </Col>
                        {/* <Col sm="6">
                          <Row>
                            <Col sm="12" className="name-persnmsmall">
                              Vu sur mer
                            </Col>
                          </Row>
                        </Col> */}
                      </Row>
                    </div>
                  </Col>
                  </form>

                </Row>
                <div className="contact-detail">
                  <Row>
                    <Col className="padding0">
                    
                      <Button className="contact" onClick={this.contactAnnouncer}>
                        Contacter l'annonceur
                        <img
                          src="/imgs/resrervationIcons/annoncer-contacts.svg"
                          alt=""
                          className="profile-iconOr icon-cnt-fr"
                        />
                      </Button>
                  
                    </Col>
                  </Row>
                  <Row>
                    <Col className="padding0">
                      <Button className="reserver" onClick={this.reserveForm}>
                        Réserver maintenant
                        <img
                          src="/imgs/resrervationIcons/reserverMaintenant.svg"
                          alt=""
                          className="notifHear-iconOr icon-cnt-fr"
                        />
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <Modal
          isOpen={this.state.ratingModal}
          toggle={this.toogleRatingClose.bind(this)}
          className="rating-modal"
        >
          <ModalBody>
            <center>
              <h2>évaluer notre Hebergement</h2>
              <Rating change={true} starts={0} size={"2.5rem"} />
            </center>
            <br />
            <br />
            <Button
              className="quitter-btn"
              onClick={this.toogleRatingClose.bind(this)}
            >
              Quitter
            </Button>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    rating : state.comment.rating,
    comment : state.comment
  };
}

//connect function INJECTS dispatch function as a prop!!
export default withRouter(connect(mapStateToProps)(DetailsGhurfaty));
